export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'APPLICATIONS',
            'SAMPLE': {
                'TITLE': 'Sample',
                'BADGE': '25'
            },
            'CUSTOM-FUNCTION': 'CUSTOM FUNCTION',
            'CUSTOMIZE': 'Customize',
            'MONITORING': 'Monitoring',
            'DASHBOARD': 'Dashboard',
            'GNC': 'Continuous improvement',
            'NON-CONFORMITE': 'Non-conformances',
            'CALENDAR': 'Calendar',
            'AUDIT': 'Audit',
            'NORME': 'Standard',
            'CHAPITRE': 'Chapter',
            'RECLAMATION': 'Complaints',
            'ACTIONS': 'Actions',
            'BILAN_ANALYSE': 'Review and analysis',
            'ENQUETE': 'Satisfaction surveys',
            'GED': 'DMS',
            'DOCS': 'Documents',
            'DOCS_INTERNES': 'Internals',
            'DOCS_EXTERNES': 'Externals',
            'TAB_BORD': 'Dashboard',
            'ENREGISTREMENTS': 'Records',
            'EDITIONS': 'Editions',
            'FORMS': 'Forms',
            'PAPIERS': 'Papers',
            'GRH': 'HRM',
            'EMPLOYES': 'Employees',
            'POSTE': 'Job descriptions',
            'QUESTIONNAIRE': 'Evaluation quizzes',
            'INDICATEUR': 'Indicators',
            'AUDITS': 'Audits',
            'RISK_MANGEMENT': 'Risk management',
            'SETTING': 'Settings',
            'GENERAL': 'General',
            'PAYS': 'Countries',
            'CITY': 'Cities',
            'PROCESS': 'Process',
            'SITE': 'Sites',
            'SUJET': 'Subjects',
            'IMPACT': 'Impacts',
            'INCIDENCE': 'Incidences',
            'FREQUENCE': 'Frequencies',
            'DETECTABILITE': 'Detectability',
            'PREUVE_EFFICACITE': 'Proof of effectiveness',
            'ETAT_ACTION': 'Action states',
            'CATEGORIE_EMETTEUR': 'Issuer categories',
            'BATTERIE_QUESTION': 'Battery of questions',
            'TYPE_DOC_EXTERNE': 'External docs types',
            'ORIGINE_DOC_EXTERNE': 'External docs sources',
            'PARTIE_INTERESSEE': 'Stakeholders',
            'TYPE_ENREGISTREMENT': 'Records types',
            'ETABLISSEMENT': 'Establishments',
            'TYPE_DIPLOME': 'Types of qualifications',
            'SPECIALITE': 'Majors',
            'DOMAINE_COMPETENCE': 'Areas of expertise',
            'COMPETENCE': 'Skills',
            'ACTION_FORMATION': 'Training actions',
            'CRITERE_MAINTIEN': 'Retention conditions',
            'SERVICE': 'Services',
            'VACCINATION': 'Vaccines',
            'QUESTION_EVALUATION': 'Evaluation questions',
            'GESTION_ACCES': 'Access management',
            'USERS': 'Users',
            'ROLES': 'Roles',
            'TYPEPANNE': 'Types of breakdowns',
            'INTERVENTION': 'Interventions',
            'PIECE': 'Pieces',
            'TACHE': 'Tasks',
            'TYPEINTERVENTION': 'Types of Interventions',
            'TYPETACHEINTERVENTION': 'Types of Task for Interventions',
            'UNITEDUREE': 'Duration Unit',
            'STATUTTACHE': 'Task Status',
            'MAINTENANCE': 'Maintenance',
            'Marque': 'Brands',
            'Model': 'Models',
            'Criticite': 'Criticities',
            'Type': 'Types',
            'Fournisseur': 'Providers',
            'ETAT': 'Reception Status',
            'CHAMPUTILISATION': 'Field Use',
            'DISCIPLINE': 'Disciplines',
            'EMPLACEMENT': 'Locations',
            'CLIENT': 'Clients',
            'GMAO': 'CMMS',
            'EQUIPEMENT': 'Equipements',
            'PANNE': 'Breakdowns',
            'PRIORITE': 'Priority',
            'RISK': 'Risks',
            'ASSESSMENT': 'Assessment',
            'HIGHRISK': 'Warning',
            'SEVERITY': 'Severities',
            'CRITICALITY': 'Criticalities',
            'HIGHRISKPARAMS': 'High risk parameter',
            'REVUE_DIRECTION': 'Management review',
            'GED_STAT': 'Statistics',
            'RECENT': 'Recent documents',
            'GROUPE': 'Groups',
            'ACTIONLOG': 'Action log',
            'RAPPEL': 'Reminders parameters',
            'STOCK': 'Stock',
            'ARTICLE': 'Articles',
            'FAMILLE' : 'Family',
            'TYPE_ARTICLE' : 'Article Type',
            'UNITE' : 'Unit',
            'CONTACT_FOURNISSEUR' : 'Supplier Contact',
            'DEMANDEACHAT': 'Purchase Request',
            'BCMD': 'Purchase Orders',
            'BRECEP' : 'Reception Orders',
            'BOUT': 'Outgoing Orders',
            'BIN': 'Incoming Orders',
            'BRET': 'Return Orders',
            'INVENTAIRE': 'Inventories',
            'FACTURE': 'Invoices',
            'REGLEMENT' : 'Payments',
            'BANQUE' : 'Bank',
            'MODE_PAIEMENT' : 'Payment Mode',
            'CAISSE' : 'Cashbox',
            'LIST_STOCK' : 'Stocks list',
            'LOT_EN_STOCK' : 'Stock lots',
            'SITUATION_FOURNISSEUR' : 'Suppliers situation',
            'DOCUMENTATION': 'Documentation',
            'RATING': 'Rating',
            'COMPAGNE': 'Compagne',
            'VALUERATING': 'Rating values',
            'OPTIONS_GENERALES': 'General settings',
            'BORNE': 'Fireborne',
            'TODO':'To-Do',
            'TODO_LIST':'To-Do',
            'EVALUATION_FOURNISSEUR': 'Supplier evaluation',
            'CRITERE_EVALUATION_FOURNISSEUR': 'Evaluation criteria',
            'CATEGORIE_FOURNISSEUR': 'Categories',
            'EVAL': 'Supplier evaluation',
            'EVALUATION_CATEGORIE_FOURNISSEUR': 'Category evaluation',
        
        }
    }
};
